import React from "react";
import { connect } from "react-redux";
import { Field, reduxForm } from "redux-form";

import klerData from "../../apis/klerData";
const azure = require("azure-storage/browser/azure-storage.blob.export");

class DeleteRecord extends React.Component {
  render() {
    const deleteRecord = formValues => {
      // **************************
      // DELETE MEDIA
      klerData
        .delete(`/Media(${formValues.Oid})`)
        .then(result => {
          clearMenuItems(formValues.Oid);
        })
        .catch(error =>
          this.setState({
            error
          })
        );

      // **************************
      // SELECT RECORD
      const clearMenuItems = mediaId => {
        klerData
          .get(
            `/MenuItems?$filter=MediaToShow/Oid eq ${mediaId}&$select=Oid,Name&$expand=MediaToShow&$format=json`
          )
          .then(result => {
            deleteMenuItemsRecord(result.data.d[0].Oid);
          })
          .catch(error =>
            this.setState({
              error
            })
          );
      };

      // **************************
      // DELETE MENU ITEMS
      const deleteMenuItemsRecord = id => {
        klerData
          .delete(`/MenuItems(${id})`)
          .then(result => {
            deleteFileFromAzure();
          })
          .catch(error =>
            this.setState({
              error
            })
          );
      };

      // **************************
      // DELETE FROM AZURE
      const deleteFileFromAzure = () => {
        // DELETE FROM AZURE
        const CONNECTION_STRING =
          "DefaultEndpointsProtocol=https;AccountName=klerfiles;AccountKey=am020WmiP81hMONvb9oxuESPf3aYtxuENdZIkLpzqUJOlN3D2nApGmNH5VeBo6bYsXWhrZzRb3FkEkwOZnqAsw==;EndpointSuffix=core.windows.net";
        const BlockBlobContainerName = formValues.SubscriptionId;
        var BlobName = formValues.Url.split("/").pop();
        console.log({ message: `Block blob '${BlobName}' deleted` });

        var blobService = azure.createBlobService(CONNECTION_STRING);

        blobService.deleteBlobIfExists(
          BlockBlobContainerName,
          BlobName,
          err => {
            if (err) {
              // NEED TO FIGURE OUT A BETTER WAY TO NOTIFY
            } else {
              console.log({ message: `Block blob '${BlobName}' deleted` });
              this.props.handleCloseReload();
            }
          }
        );
        // **************************
        // DELETE COMPLETE
      };
    };
    const onSubmit = formValues => {
      deleteRecord(formValues);
    };
    return (
      <div className="txt-center">
        <div>Are you sure you want to delete?</div>
        <div>
          <h4>{this.props.data.Name}</h4>
        </div>
        <form onSubmit={this.props.handleSubmit(onSubmit)}>
          <div>
            <Field
              name="Oid"
              component="input"
              type="hidden"
              autoComplete="off"
            />
            <Field
              name="Url"
              component="input"
              type="hidden"
              autoComplete="off"
            />
            <Field
              name="SubscriptionId"
              component="input"
              type="hidden"
              autoComplete="off"
            />
          </div>
          <button className="waves-effect waves-light btn btn-small">
            Confirm
          </button>
          &nbsp;
          <button
            type="button"
            className="waves-effect waves-light btn btn-small"
            onClick={this.props.handleClose}
          >
            Cancel
          </button>
        </form>
      </div>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    initialValues: {
      Oid: ownProps.data.Oid,
      Url: ownProps.data.Url,
      SubscriptionId: ownProps.SubscriptionId
    },
    ReferenceTable: ownProps.ReferenceTable
  };
};

export default connect(mapStateToProps)(
  reduxForm({
    form: "DeleteRecord"
  })(DeleteRecord)
);
